export class PartnerSettings {
  constructor(proService) {
    this.proService = proService;
    this._settings = {
      isAuthenticated: false,
      primarySite: {
        previewUrl: null
      }
    };
    this.addDummySettins();
  }
  get settings() {
    if (this.proService.session && !this._settings.primarySite.previewUrl) {
      this.addDummySettins();
    }
    return this._settings;
  }
  addDummySettins() {
    let previewUrl = null;
    if (this.proService.session) {
      if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
        if (this.proService.session.currentAccount.id === "FI03POYA0003689675" || this.proService.session.currentAccount.id === "FI79POYA0009321679") {
          previewUrl = "http://localhost:9001/test-frameset-accountor-go.html";
        } else if (this.proService.session.currentAccount.id === "FI15POYA0008369224") {
          previewUrl = "http://localhost:9001/test-frameset-finago.html";
        } else {
          previewUrl = `${window.salaxy.config.wwwServer}/Security/Authenticate`;
        }
      } else if (this.proService.isInRole("test")) {
        if (this.proService.session.currentAccount.id === "FI03POYA0003689675" || this.proService.session.currentAccount.id === "FI79POYA0009321679") {
          previewUrl = "https://test-finago.palkkaus.fi/test-frameset-accountor-go.html";
        } else if (this.proService.session.currentAccount.id === "FI15POYA0008369224") {
          previewUrl = "https://test-finago.palkkaus.fi/test-frameset-finago.html";
        } else if (this.proService.session.currentAccount.id === "FI51POYT0031925356") {
          previewUrl = "https://test-palkkapalvelu.palkkaus.fi/";
        } else {
          previewUrl = `${window.salaxy.config.wwwServer}/Security/Authenticate`;
        }
      } else {
        if (this.proService.session.currentAccount.id === "FI03POYA0003689675" || this.proService.session.currentAccount.id === "FI79POYA0009321679") {
          previewUrl = "https://finago.palkkaus.fi/test-frameset-accountor-go.html";
        } else if (this.proService.session.currentAccount.id === "FI15POYA0008369224") {
          previewUrl = "https://finago.palkkaus.fi/test-frameset-finago.html";
        } else if (this.proService.session.currentAccount.id === "FI51POYT0031925356") {
          previewUrl = "https://palkkapalvelu.palkkaus.fi/";
        } else {
          previewUrl = `${window.salaxy.config.wwwServer}/Security/Authenticate`;
        }
      }
    }
    this._settings = {
      isAuthenticated: true,
      primarySite: {
        previewUrl
      }
    };
  }
}
PartnerSettings.$inject = ["SessionService"];
